export default {
    namespaced: true,

    state: {
        activeTab: 'all-results',
        selectedCrewId: null
    },

    getters: {
        activeTab: state => state.activeTab,
        selectedCrewId: state => state.selectedCrewId
    },

    mutations: {
        updateTab(state, tab) {
            state.activeTab = tab;
        },
        setSelectedCrewId(state, id) {
            state.selectedCrewId = id;
        }
    }
};
